import { connect, ConnectedProps } from 'react-redux'
import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import LoaderDecider from '../../../../../../../../../baseComponents/LoaderDecider'
import TwinForm from '../../../../../../../../../forms/TwinForm'
import DefaultMainLeftProductLayout from '../../../../../../../../../specificComponents/Product/ProductLayout/LeftSide/DefaultMainLeftProductLayout'
import ShortMainRightProductLayout from '../../../../../../../../../specificComponents/Product/ProductLayout/RightSide/ShortMainRightProductLayout'
import { ProductLayoutWithDelete } from '../../../../../../../../../specificComponents/Product/ProductLayout'
import withLoading from '../../../../../../../../../utils/hoc/withLoading'
import useIsLoading from '../../../../../../../../../utils/hooks/useIsLoading'
import useLangData from '../../../../../../../../../utils/hooks/useLangData'
import { AllReduxPayloads } from '../../../../../../../../../utils/reducers'
import { GroupVatPayload } from '../../../../../../../../../utils/reducers/globals/groupVats'
import { ProductExtendedTyShort } from '../../../../../../../../../specificComponents/Product/types'

interface MainPackagingProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
    getData: () => Promise<void>
}

const MainPackaging: React.FC<MainPackagingProps & ReduxProducts> = ({ basicData, getData, userPermissions }) => {
    const langData = useLangData({ myData: basicData?.ProductLangs, fieldsToLang: ['name', 'shortDescription', 'description', 'descriptionDocuments', 'shortDescriptionDocuments'], keyValue: 'LangId' })
    const { startLoading, endLoading, loading } = useIsLoading()

    return (
        <TwinForm className='flex flex-auto h-1' action='/api/app/product/updateProduct' imagepath={['product', String(basicData?.id)]} onSubmit={() => { endLoading(); getData() }} beforeSubmitHandler={startLoading} onError={endLoading} >
            <LoaderDecider loading={langData.data ? false : true}>
                <ProductLayoutWithDelete basicData={basicData} userPermissions={userPermissions} buttonIsDisabled={loading} locationPath='packaging' getData={getData}>
                    <div className='product_container flex flex-wrap'>
                        <DefaultMainLeftProductLayout  {...{ ...langData, basicData, getData, userPermissions, data: langData.data || {} }} />
                        <ShortMainRightProductLayout {...{ basicData, userPermissions, changeLang: langData.changeLang, selectedLang: langData.selectedLang }} />
                    </div>
                </ProductLayoutWithDelete>
            </LoaderDecider>
        </TwinForm >
    )
}

const productDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
}

const mapProductConnect = (state: AllReduxPayloads) => ({ groupVats: state.groupVats })
const productConnect = connect(mapProductConnect, productDispatch)
export type ReduxProducts = ConnectedProps<typeof productConnect>

const productConnectLoading = withLoading(MainPackaging, [
    { fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' },
])

const MainPackagingConnect = productConnect(productConnectLoading)

export default MainPackagingConnect
